import React from "react";

const PricingNotes = () => {
  return (
    <div className="mt-16 max-w-5xl mx-auto px-6 lg:px-8">
    <div className="mt-14 bg-white border border-border/50 rounded-xl p-6 brand-shadow">
      <h3 className="text-lg font-bold text-foreground flex items-center gap-2">
        <span className="w-1.5 h-5 bg-primary rounded-full"></span>
        Important Notes
      </h3>

      <ul className="mt-4 space-y-3 text-sm text-foreground leading-relaxed">
        <li className="font-semibold">
          • Charges apply only for requests beyond the initially agreed scope of
          work.
        </li>

        <li className="font-semibold">
          • All add-on prices mentioned are starting estimates and may vary based
          on feature complexity and effort involved.
        </li>

        <li className="font-semibold">
          • Once a feature is developed based on client approval, any later
          request to remove or discard that feature will still be chargeable, as
          development effort cannot be reversed.
        </li>

        <li className="font-semibold">
          • If the project is paused, stopped, or dropped from the client’s end
          at any stage, no amount paid will be refunded.
        </li>

        <li className="font-semibold">
          • Testing costs are charged separately and depend on your{" "}
          <span className="font-bold">
            Play Console / App Store developer account
          </span>{" "}
          status. Final testing charges will be shared after account details are
          disclosed.
        </li>

        <li className="font-semibold">
          • Any testing, changes, documentation updates, or compliance
          requirements requested at the time of deployment on the client’s
          developer account will be billed based on time and effort involved.
        </li>

        <li className="font-semibold">
          • Due to new features or add-ons beyond the initial scope, additional
          deployment charges may apply. The applicable deployment charge range
          has been mentioned above.
        </li>

        <li className="font-semibold">
          • In case maintenance services are not opted for, we will not be
          responsible for app downtime, crashes, compatibility issues, or
          failures occurring after successful deployment.
        </li>

        <li className="font-semibold">
          • Our scope includes only app development. All graphics, images, and
          assets should be provided by the client. If assets are required from
          our side, they will be chargeable separately.Source Code Handover is chargeable at ₹70K. If required, it must be communicated at the beginning of the project, as it impacts overall project cost, scope, and delivery planning.

        </li>

        <li className="font-semibold">
          • The Basic plan includes free application screenshots (standard or
          auto-generated).
        </li>

        <li className="font-semibold">
          • Custom-designed screenshots, app logo, store creatives, or branding
          assets are chargeable as per the design pricing mentioned.
        </li>

        <li className="font-semibold">
          • Third-party services (APIs, servers, voice/video services, etc.) may
          involve additional recurring or usage-based costs, payable directly by
          the client.
        </li>
      </ul>
    </div></div>
  );
};

export default PricingNotes;
